import { useGetAllActionPlan } from "src/api/client-api/ActionPlan/ActionPlan/useGetAllActionPlan";
import { useGetOneActionPlan } from "src/api/client-api/ActionPlan/ActionPlan/useGetOneActionPlan";
import { useEntityBasedScoreParams } from "../EntityBasedScore/useEntityBasedScoreParams";

type Options = {
    params?: AxiosParams;
};

export const useGetOneAction = (options?: Options) => {
    const { params } = options || {};
    const {
        data: _actionPlan,
        isFetched: areAllActionsPlansFetched,
        isRefetching: areAllRefetching,
    } = useGetAllActionPlan({
        queryParam: params,
    });

    const selectedActionPlanID = _actionPlan !== undefined && _actionPlan.length > 0 ? _actionPlan[0].id : undefined;

    const { query, state } = useEntityBasedScoreParams({
        initDimensions: { dimensions: [["properties", "subproperties", "multivalues"]] },
    });
    const {
        data: actionPlan,
        isFetched: isSingleActionPlanFetched,
        isRefetching: isSingleRefetching,
    } = useGetOneActionPlan({ actionPlanId: selectedActionPlanID, scoreQuery: query });

    const isFetched =
        areAllActionsPlansFetched ?
            (_actionPlan ?? []).length > 0 ?
                isSingleActionPlanFetched && areAllActionsPlansFetched
            :   areAllActionsPlansFetched
        :   areAllActionsPlansFetched;

    const isRefetching =
        areAllRefetching ?
            (_actionPlan ?? []).length > 0 ?
                isSingleRefetching && areAllRefetching
            :   areAllRefetching
        :   areAllRefetching;

    return {
        actionPlan,
        scoreState: state,
        isFetched,
        isRefetching,
    };
};
